import { apiClient, handleApiRequest } from './client'

export interface CollectionPhaseData {
  request_id: string
  requesting_teacher_name: string
  date: string
  lessons: Array<{
    lesson_request_id: string
    lesson_number: number
    subject_name: string
    klass_name: string
    room_name: string
    time_slot_name: string
    start_time: string
    end_time: string
    date: string
  }>
  allow_definitive_full_day: boolean
  available_full_day_dates: string[]
  deadline: string | null
  already_responded?: boolean
  phase?: string
}

export interface CommitPhaseData {
  request_id: string
  requesting_teacher_name: string
  date: string
  lessons: Array<{
    lesson_request_id: string
    lesson_number: number
    subject_name: string
    klass_name: string
    room_name: string
    time_slot_name: string
    start_time: string
    end_time: string
    date: string
  }>
  deadline: string | null
}

export const smartBatchApi = {
  getCollectionPhase: (token: string) =>
    handleApiRequest<CollectionPhaseData>(
      apiClient.get(`/api/v1/smart-batch/collection/${token}`)
    ),

  respondToCollection: (token: string, data: {
    lesson_interests?: Array<{ lesson_request_id: string; status: string }>
    accept_full_day_definitive?: boolean
    target_date?: string
  }) =>
    handleApiRequest<{ success: boolean; message: string }>(
      apiClient.post(`/api/v1/smart-batch/collection/${token}/respond`, data)
    ),

  getCommitPhase: (token: string) =>
    handleApiRequest<CommitPhaseData>(
      apiClient.get(`/api/v1/smart-batch/commit/${token}`)
    ),

  respondToCommit: (token: string, data: { accepted: boolean }) =>
    handleApiRequest<{ success: boolean; message: string }>(
      apiClient.post(`/api/v1/smart-batch/commit/${token}/respond`, data)
    ),

  getCollectionStatusInApp: (requestId: string) =>
    handleApiRequest<CollectionPhaseData>(
      apiClient.get(`/api/v1/smart-batch/requests/${requestId}/collection-status`)
    ),

  respondToCollectionInApp: (requestId: string, data: {
    lesson_interests?: Array<{ lesson_request_id: string; status: string }>
    accept_full_day_definitive?: boolean
    target_date?: string
  }) =>
    handleApiRequest<{ success: boolean; message: string }>(
      apiClient.post(`/api/v1/smart-batch/requests/${requestId}/collection/respond`, data)
    ),

  respondToCommitInApp: (requestId: string, data: { accepted: boolean }) =>
    handleApiRequest<{ success: boolean; message: string }>(
      apiClient.post(`/api/v1/smart-batch/requests/${requestId}/commit/respond`, data)
    ),
}
